export const chartPeriodArray: ['last24Hours', 'last7Days', 'last30Days', 'last12Months', 'daily', 'weekly', 'monthly', 'annual']
  = ['last24Hours', 'last7Days', 'last30Days', 'last12Months', 'daily', 'weekly', 'monthly', 'annual'];

export const entityCategoryArray: [ 'groups', 'rooms', 'air-machines' ]
  = [ 'groups', 'rooms', 'air-machines' ];
